import React from 'react';
import { useCart } from '../../context/CartContext';
import { MinusIcon, PlusIcon, TrashIcon } from '@heroicons/react/24/outline';

const Cart = ({ handleOrder }) => {
    const { cart, removeFromCart, updateQuantity, getTotal, refillCapsules, orderProducts } = useCart();

   

    if (cart.length === 0) {
        return (
            <div className="p-4 text-center text-gray-500">
                Votre panier est vide
            </div>
        );
    }

    return (
        <div className="flex flex-col h-full max-h-[calc(100vh-8rem)]">
            <div className="flex-grow overflow-auto">
                {cart.map((item) => (
                    <div key={item.id} className="p-3 border-b border-gray-100 hover:bg-gray-50">
                        <div className="flex items-center gap-3">
                            <img
                                src={item.imageUrl || '/assets/images/default-product-image.svg'}
                                alt={item.name}
                                className="w-12 h-12 object-cover rounded-lg"
                            />
                            <div className="flex-grow min-w-0">
                                <h3 className="font-medium text-sm text-gray-800 truncate">{item.name}</h3>
                                <p className="text-primary font-bold text-sm">{item.price} €</p>
                            </div>
                            <button
                                onClick={() => removeFromCart(item.id)}
                                className="text-gray-400 hover:text-red-500 transition-colors"
                            >
                                <TrashIcon className="h-4 w-4" />
                            </button>
                        </div>
                        <div className="flex items-center justify-end mt-2 gap-2">
                            <button
                                onClick={() => updateQuantity(item.id, item.quantity - 1)}
                                className="btn btn-xs btn-ghost p-1"
                                disabled={item.quantity <= 1}
                            >
                                <MinusIcon className="h-3 w-3" />
                            </button>
                            <span className="text-sm font-medium w-6 text-center">{item.quantity}</span>
                            <button
                                onClick={() => updateQuantity(item.id, item.quantity + 1)}
                                className="btn btn-xs btn-ghost p-1"
                            >
                                <PlusIcon className="h-3 w-3" />
                            </button>
                        </div>
                    </div>
                ))}
            </div>
            <div className="border-t border-gray-200 p-4 bg-white">
                <div className="flex justify-between items-center mb-4">
                    <span className="font-bold text-gray-700">Total:</span>
                    <span className="font-bold text-primary text-xl">{getTotal().toFixed(2)} €</span>
                </div>
                <button className="btn btn-primary w-full" onClick={handleOrder}>
                    Commander
                </button>

            </div>
        </div>
    );
};

export default Cart;
